import { MouseEvent, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useForm } from 'react-hook-form';

import { useAppDispatch } from '../../app/hooks';
import {
  createRoleBindingAction,
  userRoleBindingFieldOptions,
} from './roleBindingSlice';
import { UserRoleBinding } from '../../types';

type Props = {
  tenant_id: string;
  role_id?: string;
  user_id?: string;
  show: boolean;
  onClose: () => void;
};

const initialState: Pick<UserRoleBinding, 'role_id'|'user_id'> = {
  role_id: '',
  user_id: '',
};

export function CreateUserRoleBindingModal({ tenant_id, show, role_id, user_id, onClose }: Props) {
  const dispatch = useAppDispatch();
  const { register, reset, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { ...initialState, role_id, user_id },
  });

  useEffect(() => {
    if (show) {
      reset({ ...initialState, role_id, user_id });
    }
  }, [show, reset, role_id, user_id]);

  const handleCreate = async(data: typeof initialState) => {
    await dispatch(createRoleBindingAction({
      tenant_id,
      body: {
        type: 'user',
        ...data,
      },
    }));
    onClose();
  };
  const handleClose = (e: MouseEvent) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Create Role binding</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <fieldset>
            <div className="mb-3 row">
              <label htmlFor="role_id" className="col-sm-3 col-form-label">RoleId</label>
              <div className="col-sm-6">
                <input readOnly={!!role_id} type="text" id="role_id" className="form-control"
                  { ...register('role_id', userRoleBindingFieldOptions.role_id) }
                />
              </div>
              <span className="col-sm-3 text-danger py-1">{errors.role_id?.message}</span>
            </div>
            <div className="mb-3 row">
              <label htmlFor="user_id" className="col-sm-3 col-form-label">UserId</label>
              <div className="col-sm-6">
                <input readOnly={!!user_id} type="text" id="user_id" className="form-control"
                  { ...register('user_id', userRoleBindingFieldOptions.user_id) }
                />
              </div>
              <span className="col-sm-3 text-danger py-1">{errors.user_id?.message}</span>
            </div>
          </fieldset>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={(e) => handleClose(e)}>
          Close
        </button>
        <button type="submit" className="btn btn-primary" onClick={(e) => handleSubmit(handleCreate)(e)}>
          Create
        </button>
      </Modal.Footer>
    </Modal>
  );
}

